import type { CodeEditorProps } from '../CodeEditor';
import { CodeEditor } from '../CodeEditor';
import { InputBox, type InputBoxProps } from './InputBox';

export type CodeInputProps = CodeEditorProps & Pick<InputBoxProps, 'state'>;

export const CodeInput = ({ state = 'normal', ...props }: CodeInputProps) => {
  return (
    <InputBox state={state}>
      <CodeEditor {...props} />
    </InputBox>
  );
};
